<template>
  <div class="eb-header">
    <div class="main-header-component-body">
      <div >
        <BtnAsideHide class="main-header-component-aside-btn-box"/>
      </div>
      <div class="main-header-break-crumb-box">
        <slot name="breakCrumb"></slot>
      </div>
      <slot name="middle"></slot>
      <div class="main-header-component-search-box">
        <slot name="search"></slot>
      </div>
    </div>
  </div>
</template>
<script>
import BtnAsideHide from '@/components/common/button/aside/Hide';
export default {
  name: 'ebHeader',
  components: {
    BtnAsideHide
  }
};
</script>
<style scoped lang="less">
.eb-header {
  height: 70px;
  border-bottom: 1px solid #fff;
  .main-header-component-body {
    padding-left:16px;
    height: 69px;
    border-bottom: 1px solid #dfdfdf;
  }
  .main-header-component-aside-btn-box {
    width: 53px;
    height: 52px;
    padding: 19px 15px 0 0;
    float: left;
  }
  .main-header-component-break-crumb-box {
    float: left;
    padding-top: 2px;
    height: 66px;
    line-height: 66px;
  }
  .main-header-component-search-box {
    float: right;
    padding-top: 27px;
    padding-right: 48px;
  }
  .main-header-break-crumb-box {
    float: left;
    padding-top: 28px;
  }
}
</style>
